<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
		<defs>
			<clipPath id="clip-path-linkedsins">
				<rect id="Rectangle_15497" data-name="Rectangle 15497" width="20" height="20" fill="#fff" stroke="#707070" stroke-width="1" />
			</clipPath>
		</defs>
		<g id="Mask_Group_44948" data-name="Mask Group 44948" clip-path="url(#clip-path-linkedsins)">
			<g id="Layer_1-2">
				<circle id="Ellipse_927" data-name="Ellipse 927" cx="10" cy="10" r="10" fill="#fff" />
				<path
					id="Path_33041"
					data-name="Path 33041"
					d="M10,0A10,10,0,1,0,20,10,10.016,10.016,0,0,0,10,0ZM6.96,14.35H5.22V7.83H6.96ZM6.09,6.52a.87.87,0,1,1,.87-.87A.871.871,0,0,1,6.09,6.52Zm9.13,7.83H13.48V11.09a1.52,1.52,0,1,0-3.04,0v3.26H8.7V7.83h1.74v.79a2.829,2.829,0,0,1,4.79,2.04v3.7Z"
					fill="#969bae"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'LinkedInSvg',
};
</script>
